<template>
  <div>
    <Modal
      v-model="previewVisible"
      :closable="true"
      :mask-closable="false"
      :width="960"
      footer-hide
      class="modal"
    >
      <div slot="header">
        <p>
          <i class="fas fa-eye" />
          <span class="description">
            File Preview
          </span>
        </p>
      </div>
      <div class="file-preview">
        <img
          v-if="filePreview.isImage"
          :src="filePreview.src"
        >
      </div>
    </Modal>
    <Spin
      v-if="loading"
      fix
    >
      <i
        class="fas fa-spinner fa-spin"
        style="font-size: 20px; color: var(--color-green-thick);"
      />
      <p>Loading</p>
    </Spin>
    <div
      v-else-if="!loading && files.length"
      class="preview-container"
    >
      <div
        v-for="(file, index) in files"
        :key="index"
        class="item"
      >
        <img
          v-if="file.isImage"
          :src="file.src"
        >
        <div class="item-actions">
          <i
            class="fas fa-eye"
            @click="previewFile(file)"
          />
          <i
            v-if="editable"
            class="fas fa-trash-alt"
            @click="deleteFile(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false,
      previewVisible: false,
      filePreview: {}
    }
  },

  methods: {
    /**
     * Opens a modal to preview a file.
     * @param {Object} file
     */
    previewFile (file) {
      this.filePreview = file
      this.previewVisible = true
    },

    /**
     * Removes a file from the preview container.
     * @param {Number} index
     */
    deleteFile (index) {
      this.$emit('onDeleteFile', index)
    }
  }
}
</script>

<style scoped>
.file-preview {
  width: 100%;
  height: 560px;
  position: relative;
  display: flex;
  justify-content: center;
}

.file-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: scale-down;
}

.preview-container {
  padding: 8px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.preview-container .item {
  margin-left: 8px;
  width: 56px;
  height: 56px;
  position: relative;
  display: flex;
  border: 1px solid var(--color-gray-border);
  border-radius: 8px;
  overflow: hidden;
}

.preview-container .item:first-child {
  margin-left: 0;
}

.preview-container .item img,
.preview-container .item div {
  width: 100%;
  height: 100%;
}

.preview-container .item .item-actions {
  display: none;
  position: absolute;
  background-color: rgba(0, 0, 0, .8);
  border-radius: 8px;
}

.preview-container .item:hover .item-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-white);
  font-size: 13px;
}

.preview-container .item:hover .item-actions i {
  margin: 0 4px;
  cursor: pointer;
  width: 14px;
  height: 14px;
}
</style>
